/**
 * View controller base class.
 * @constructor
 * @extends {Foundation.Observable}
 * @param {jQuerySelector=} jQueryObjOrSelector
 */
Foundation.ViewController = function (jQueryObjOrSelector) {
    Foundation.Observable.call(this);

    /**
     * @protected
     * @type {Foundation.View}
     */
    this.view = null;

    if (jQueryObjOrSelector) {
        this.setView(new Foundation.View(jQueryObjOrSelector));
    }
};
Foundation.inherit(Foundation.ViewController, Foundation.Observable);

/**
 * @param {Foundation.View} aView
 */
Foundation.ViewController.prototype.setView = function (aView) {
    if (aView !== this.view) {
        this.fire("viewWillChange");
        this.view = aView;
        this.fire("viewDidChange");
    }
};

/**
 * @return {Foundation.View}
 */
Foundation.ViewController.prototype.getView = function () {
    return this.view;
};


window["Foundation"]["ViewController"] = Foundation.ViewController;
window["Foundation"]["ViewController"].prototype["getView"] = Foundation.ViewController.prototype.getView;
